import { render, staticRenderFns } from "./PolicyRules.vue?vue&type=template&id=e8f3afbc&"
import script from "./PolicyRules.vue?vue&type=script&lang=js&"
export * from "./PolicyRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports